import React, { useState } from 'react';

const InterestWallet = () => {
  // List of transactions
  const transactionData = [
    { srNo: 1, trxnNo: 'TXN585833283', name: 'ODHPAY', mobile: '8080808080', amount: 178.84, date: '03-06-2024 11:29:31 AM', remark: 'Cash Back Paid for the month May 2024', status: 'Added' },
    { srNo: 2, trxnNo: 'TXN691615723', name: 'Mayank Pal', mobile: '7786042003', amount: 120.57, date: '03-06-2024 11:28:27 AM', remark: 'Cash Back Paid for the month May 2024', status: 'Added' },
    { srNo: 3, trxnNo: 'TXN827188324', name: 'N/A', mobile: '9682777555', amount: 286.14, date: '03-06-2024 11:27:46 AM', remark: 'Cash Back Paid for the month May 2024', status: 'Added' },
    { srNo: 4, trxnNo: 'TXN394329237', name: 'ASIYA SIDDIQUI', mobile: '9336269364', amount: 16.89, date: '03-06-2024 11:26:51 AM', remark: 'Cash Back Paid for the month May 2024', status: 'Added' },
  ];

  // Calculate total interest
  const totalInterest = transactionData.reduce((sum, transaction) => sum + transaction.amount, 0).toFixed(2);

  const containerStyle = {
    marginTop: '50px',
    padding: '20px',
    backgroundColor: '#f4f4f9',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '1200px',
    marginLeft: 'auto',
    marginRight: 'auto',
  };

  const totalStyle = {
    fontSize: '24px',
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: '20px',
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '30px',
    tableLayout: 'auto',
  };

  const thTdStyle = {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'left',
  };

  const thStyle = {
    backgroundColor: '#f1f1f1',
    fontWeight: 'bold',
  };

  return (
    <div style={containerStyle}>
      {/* Total Interest Section */}
      <div style={totalStyle}>
        <h2>Interest on Wallet</h2>
        <p>Total: ₹{totalInterest}</p>
      </div>

      {/* Transaction Table */}
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={{ ...thTdStyle, ...thStyle }}>Sr. No.</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Trxn. No.</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Name</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Mobile</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Amount</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Date</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Remark</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {transactionData.map((transaction) => (
            <tr key={transaction.srNo}>
              <td style={thTdStyle}>{transaction.srNo}</td>
              <td style={thTdStyle}>{transaction.trxnNo}</td>
              <td style={thTdStyle}>{transaction.name}</td>
              <td style={thTdStyle}>{transaction.mobile}</td>
              <td style={thTdStyle}>₹{transaction.amount.toFixed(2)}</td>
              <td style={thTdStyle}>{transaction.date}</td>
              <td style={thTdStyle}>{transaction.remark}</td>
              <td style={thTdStyle}>{transaction.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InterestWallet;
